import { render, staticRenderFns } from "./FormLongTerm.vue?vue&type=template&id=1bdf7c15&"
import script from "./FormLongTerm.vue?vue&type=script&lang=ts&"
export * from "./FormLongTerm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VInput,VRow})
